import { render, staticRenderFns } from "./PhotographyFramingSection.vue?vue&type=template&id=3a6f64f4"
import script from "./PhotographyFramingSection.vue?vue&type=script&lang=ts"
export * from "./PhotographyFramingSection.vue?vue&type=script&lang=ts"
import style0 from "./PhotographyFramingSection.vue?vue&type=style&index=0&id=3a6f64f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports